export const navLinks = [
  { label: '首页', href: '/' },
  { label: '赛事直播', href: '/category/live' },
  { label: '竞猜中心', href: '/category/betting' },
  { label: '新闻资讯', href: '/category/news' },
  { label: '关于我们', href: '/about' },
];

export const footerLinks = {
  services: [
    { label: '赛事直播', href: '/category/live' },
    { label: '数据竞猜', href: '/category/betting' },
    { label: '体育资讯', href: '/category/news' },
    { label: 'VIP会员', href: '/vip' },
    { label: 'APP下载', href: '/app' },
  ],
  sports: [
    { label: '足球赛事', href: '/category/football' },
    { label: '篮球赛事', href: '/category/basketball' },
    { label: '网球赛事', href: '/category/tennis' },
    { label: '电竞比赛', href: '/category/esports' },
    { label: '综合体育', href: '/category/other' },
  ],
  about: [
    { label: '品牌介绍', href: '/about' },
    { label: '联系我们', href: '/about#contact' },
    { label: '用户协议', href: '/terms' },
    { label: '隐私政策', href: '/privacy' },
    { label: '常见问题', href: '/faq' },
  ],
};

export const siteInfo = {
  name: '米乐体育',
  slogan: '专业体育赛事直播与竞猜平台',
  description: '米乐体育是专业的体育综合服务平台，提供足球、篮球、网球等热门赛事直播、数据分析与竞猜服务。汇聚全球顶级联赛资源，为体育爱好者带来极致观赛体验与互动乐趣。',
  phone: '400-888-6666',
  email: 'service@milesports.com',
  address: '上海市浦东新区陆家嘴金融贸易区世纪大道100号',
  icp: '沪ICP备2024XXXXXXXX号-1',
};